import { API } from "./baseService";
import APP_CONST from "../../core/shared/constants";


export const doGetUserInfo = () => {
  const contextPath = APP_CONST.API.ACCOUNT_INFO;
  return API.get(contextPath, { type: APP_CONST.API.BASE_VIEDOC_URL });
};

export const doGetUsers = () => {
  const contextPath = APP_CONST.API.CLINIC_USERS;
  return API.get(contextPath, { type: APP_CONST.API.BASE_VIEDOC_URL });
};

export const doGetViedocInfo = () => {
  const contextPath = APP_CONST.API.VIEDOC_INFO;
  return API.get(contextPath);
};

export const doGetDocumentsBySection = (sectionID) => {
  const contextPath = APP_CONST.API.DOCUMENT_ZONE_DETAILS;
  return API.get(`${contextPath}/${sectionID}`);
};

export const doGetDocumentsByArtifact = (artifactID) => {
  const contextPath = APP_CONST.API.DOCUMENT_BY_ARTIFACT;
  return API.get(`${contextPath}/${artifactID}`);
};

export const doGetMetricsData = (payload) => {
  const contextPath = APP_CONST.API.METRICS + "?"
  return API.get(
    `${contextPath}siteid=${payload.siteID}&countrycode=${payload.countryID}&milestoneGroup=${payload.milestoneGroup}&milestoneId=${payload.milestoneId}`
  );
};

export const doGetAppInitConfig = () => {
  const contextPath = APP_CONST.API.APP_INIT_CONFIG;
  return API.get(contextPath);
};